import i18n from "i18next";
import {initReactI18next} from "react-i18next";

const resources = {
  en: {
    translation: {
      createFreeAccount: "Create your free account",
      matchWithPlayers: "Match with players and find the perfect court for your next match.",
      continueWithGoogle: "Continue with Google",
      emailAddress: "Email Address",
      continue: "Continue",
      alreadyHaveAccount: "Already have an account?",
      logIn: "Log in",
      createPasswordFor: "Let's create a password for",
      password: "Password",
      atLeast8Chars: "At least 8 characters",
      atLeast1Uppercase: "At least 1 uppercase letter",
      atLeast1Lowercase: "At least 1 lowcase letter",
      atLeast1Number: "At least 1 number",
      createAccount: "Create account",
      agreeToTerms: "By creating an account, you agree to the",
      termsOfServiceStr: "Terms of Service",
      and: "and",
      privacyPolicyStr: "Privacy Policy",
      or: "or",
      emailNotValid: "Email is not valid",
      noAccount: "Don't have an account?",
      registration: "Register",
      forgotPassword: "Forgot your password",
      fillPasswordFor: "Fill out password for",
      wrongPassword: "Wrong password. Try again",
      forgotPasswordPrompt: "Forgot your password?",
      enterPadelEmail: "Enter your Padel email below and we'll send you a link to reset it.",
      sendResetLink: "Send reset password link",
      rememberPassword: "Remember your password?",
      backToLogin: "Back to LogIn",
      requestSent: "Your request has been sent. Please check your email",
      emailSentTo: "We’ve sent an email to {{email}}. Please check your inbox and follow instructions to reset your password.",
      checkInbox: "Please check your inbox and follow instructions to reset your password.",
      didNotReceiveEmail: "Didn’t receive an email?",
      sendAgain: "Send again",
      firstThingsFirst: "First things first",
      addProfilePicture: "Add profile picture",
      addUsername: "Add username",
      hello: "Hello",
      answerQuestions: "Could you take a minute to answer a few questions about yourself? It helps to match you with the right opponents.",
      sure: "Sure!",
      skip: "Skip",
      skipForNow: "Skip for now",
      racketSportsExperience: "Do you have racket sports experience?",
      yes: "Yes",
      no: "No",
      haveNprpRating: "Do you have an NPRP rating?",
      rateSkillLevel: "How you can rate your skill level?",
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      cityPlayIn: "Which city do you play in?",
      location: "Location",
      search: "Search",
      gender: "What is your gender?",
      genderPreferenceInfo: "We know many people prefer to play mixed doubles, or just against folks of their own gender.",
      male: "Male",
      female: "Female",
      nonBinary: "Non-binary",
      showInProfile: "Show in my profile",
      dateOfBirth: "What is your date of birth?",
      memberOfPadelClub: "Are you a member of a Padel Club?",
      usedToBeMember: "Yes, I used to be a member of the club",
      howLongPlaying: "How long have you been playing?",
      lessThan1Year: "Less than 1 year",
      oneToFiveYears: "1-5 years",
      moreThanFiveYears: "More than 5 years",
      howOftenPlayPadel: "How often do you play padel?",
      almostDaily: "Almost daily",
      threeToFourTimesAWeek: "3 to 4 times a week",
      oneToTwoTimesAWeek: "1 to 2 times a week",
      weekly: "Weekly",
      aFewTimesAMonth: "A few times a month",
      rarely: "Rarely",
      anythingToAdd: "Help others get to know you.",
      describeYourself: "Say a few words about your vibe, how often you play, and what you’re looking for.",
      describeYourselfExample: "📝 Example: “New to padel, play 2–3x a week. Always looking for fun doubles partners.”",
      text: "Text",
      addIndustry: "What do you do when you’re not on the court?",
      commonTopicsInfo: "Share your industry so we can help you meet players with similar interests — on and off the court.",
      technology: "Technology",
      healthcare: "Healthcare",
      education: "Education",
      marketing: "Marketing",
      finance: "Finance",
      energy: "Energy",
      hospitality: "Hospitality",
      insurance: "Insurance",
      arts: "Arts",
      logistics: "Logistics",
      retail: "Retail",
      engineering: "Engineering",
      research: "Research",
      sports: "Sports",
      law: "Law",
      media: "Media",
      realEstate: "Real Estate",
      fashion: "Fashion",
      nonprofit: "Nonprofit",
      addSocialLinks: "Add your social links",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      customizingExperience: "Customising your experience...",
      creatingProfile: "We carefully create your profile and look for the best quality matches.",
      chooseNprpRating: "Great! Choose your NPRP rating",
      beginnerRange: "Beginner 1.0-2.5",
      intermediateRange: "Intermediate 2.6–4.0",
      advancedRange: "Advanced 4.1-5.0",
      true: "Yes",
      false: "No",
      backToWebsite: "Back to website",
      howAppWorks: "How the App Works",
      aboutUs: "About Us",
      benefits: "Benefits",
      joinWaitlist: "Join the Waitlist",
      findNextPadelPartners: "Find Your Next Padel Partners in Seconds",
      getStarted: "Get Started",
      problem: "Problem",
      solution: "Solution",
      smartMatchmaking: "Play more, search less",
      smartMatchmakingDesc: "Padel Match’s smart matchmaking connects you with the right players at the right time. Whether you’re looking for a competitive match or a casual rally, our algorithm factors in skill level, location, and availability to help you find ideal partners — fast. No more scrolling through endless groups or sending cold invites. Just easy, effortless connections that get you on the court.",
      instantChat: "Coordinate matches in seconds",
      instantChatDesc: "Once you’re matched, you can start chatting instantly — no need to swap numbers or move to another app. Padel Match’s built-in messaging makes it easy to finalize plans, discuss details, and keep the game moving. Simple, seamless communication so you can focus on playing, not planning.",
      gameNotification: "Never miss a match",
      gameNotificationDesc: "Stay in the loop with real-time notifications when someone invites you to play or a new match opens up nearby. Whether you’re looking for a last-minute game or planning your week ahead, Padel Match keeps you connected to every opportunity to hit the court.",
      courtRatingOption: "Find the best courts, every time",
      courtRatingOptionDesc: "Discover new clubs as they come online, explore ratings and reviews from other players, and compare services, amenities, and conditions — all in one place. Whether you’re hunting for a hidden gem or the best courts in town, Padel Match helps you find the perfect place to play.",
      connectWithPlayers: "Connect with matched players instantly.",
      getMatchNotifications: "Get notifications so you never miss a match.",
      discoverCourts: "Discover nearby padel courts, as new courts open with regularity.",
      whosAlreadyJoined: "Who's already joined us",
      janKowalski: "Jan Kowalski",
      aceBailey: "Ace Bailey",
      professionalSportsman: "Professional sportsman",
      miamiUSA: "Miami, USA",
      emilyJohnson: "Emily Johnson",
      studentTrainee: "Student trainee",
      bostonUSA: "Boston, USA",
      eddyChad: "Eddy Chad",
      itDeveloper: "IT developer",
      nycUSA: "NYC, USA",
      findPeople: "Find People",
      abigailMitchell: "Abigail Mitchell",
      oliviaBennett: "Olivia Bennett",
      danielHarrison: "Daniel Harrison",
      viewProfiles: "View profiles of players near you.",
      filterPlayers: "• Filter by Skill level, player type, and preferred match format (singles vs. doubles)",
      selectAndChat: "• Select players to connect and chat.",
      createOpenInvites: "• Create open match invites and let others join.",
      enterEmailJoinWaitlist: "Enter your email and join the waitlist",
      addYourEmail: "Add your Email",
      joinTheWaitlist: "Join the Waitlist",
      contactUs: "Contact Us here",
      contactEmail: "info@padelmatchapp.com",
      instagramHandle: "@padelmatchapp",
      reportIssue: "Report an Issue",
      helpCenter: "Help Center",
      findingPadelPartnersDescription: "Finding padel partners can be frustrating — whether you’re new to the sport, juggling a busy schedule, or simply looking to expand your circle. Coordinating availability, skill levels, and locations often turns what should be a fun match into a time-consuming hassle.",
      padelMatchDescription: "Padel Match takes the hassle out of finding people to play with. Our app connects you with nearby players based on your availability, location, and skill level — making it easy to set up games without endless texting or group chats. Plus, you can browse and rate local clubs, so you always know where to find great courts and a great match. Whether you’re looking for a casual hit or a new group of friends, Padel Match makes playing padel simple, social, and stress-free.",
      yourRequestHasBeenSent: "Your request has been send. Please check your email",
      changePassword: "Change password",
      enterNewPasswordForLogin: "Enter a new password that will be used to log into your account",
      repeatPassword: "Repeat password",
      passwordsDontMatch: "Passwords don't match",
      somethingWentWrong: "Something went wrong",
      padel: "Padel",
      chats: "Chats",
      noChatsYet: "You don't have any chats started yet.",
      findCompanyToPlay: "Find new players to play with!",
      findPlayers: "Find players",
      noMessages: "No messages",
      typeYourMessage: "Type your message",
      unavailable: "Unavailable",
      myPadleLocation: "My padel location",
      searchMatchesInMilesFromMe: "Search matches in a {{miles}} miles from me",
      previousPlaces: "Previous places",
      moreCount: "More {{count}}",
      available: "I am available for play",
      geolocationNotSupported: "Geolocation is not supported by this browser",
      geolocationDisabled: "Geolocation is disabled",
      tryAgain: "Try again",
      allowGeolocation: "Please grant permission to use geolocation",
      nothingYet: "Nothing yet",
      fillOutYourProfile: "Fill out your profile!",
      helpsToMatchWithOpponents: "It helps to match you with the right opponents.",
      addYourPhoto: "Add your photo",
      finishCompletingYourProfile: "Finish completing your profile",
      yourStatusUnavailable: "Your status: Unavailable",
      clickToBecomeAvailable: "Click here for players to see that you are ready to play",
      yourStatusAvailable: "Your status: Available",
      clickToBecomeUnavailable: "Click here to take a break and show that you are not ready to play.",
      peopleNearYouReadyToPlay: "People near you ready to play",
      matchesNearYouReadyToPlay: "Matches near you ready to play",
      noMatchesNearYou: "No matches near you",
      inviteSeveralPeople: "Invite several people",
      matchesInApp: "Matches in App: {{matches}}",
      visitSportClub: "Visit sport club",
      play: "Play",
      experience: "Experience",
      createAMatch: "Create a match",
      chat: "Chat",
      noPlayersNearYou: "No players near you",
      readyToPlay: "Ready to play",
      year: "year",
      years: "years",
      map: "Map",
      reviews: "Reviews",
      today: "Today",
      dAgo: "{{days}}d ago",
      bookingRequired: "Booking required",
      artificialLight: "Artificial light",
      lockerRooms: "Locker rooms",
      parkingAvailability: "Parking availability",
      noCourtsFound: "No courts found",
      noReviews: "No reviews",
      filters: "Filters",
      rating: "Rating",
      placeOptions: "Place options",
      notLessThan: "Not less than",
      clean: "Clean",
      apply: "Apply",
      all: "All",
      addCourt: "Add court",
      addMarkLocationOnMap: "Add mark location on the map",
      confirm: "Confirm",
      howWouldYouDescribeThisLocation: "How would you describe this location?",
      howManyCourtsThisPlaceOffers: "How many courts does this place offer?",
      galleryCourt: "Image Gallery",
      firstImageWillBeMain: "First image will be main",
      rateCourts: "Rate location",
      description: "Description",
      courtOrClubName: "Court or Club Name",
      addNameOfLocation: "e.g. Wynwood Padel Club",
      addYourOpinionOfThisCourt: "Add your opinion of this court",
      addMoreDescription: "Add more description",
      addCourtToMap: "Add court to map",
      areYouSureDontWantToAddTable: "Are you sure you don’t want to add a Padel Court?",
      moreNewPlacesToPlayMoreCommunity: "More new places to play - more community!",
      courtAdded: "Court added!",
      afterQuickModerationPublished: "After a quick moderation, this play area will be published.",
      thankYouForEngagement: "Thank you for your engagement!",
      cancel: "Cancel",
      address: "Address",
      enterAddress: "Enter address",
      places: "Places",
      addAPadelPlace: "Add Padel Courts",
      mailAdded: "Your mail has been added to the waitlist!",
      mailExists: "Your mail already exists in the waitlist!",
      profile: "Profile",
      logOut: "Log out",
      edit: "Edit",
      questionnaire: "Questionnaire",
      padelSkillLevel: "Padel skill level",
      participationInPadleSportsClub: "Participation in a padel sports club",
      howOftenDoYouPlayPadle: "How often do you play padel?",
      dateOfBirthOnly: "Date of birth",
      showMyAgeInProfile: "Show my age in profile",
      genderOnly: "Gender",
      preferToPlayMixedDoubles: "We know many people prefer to play mixed doubles, or just against folks of their own gender",
      showInMyProfile: "Show in my profile",
      infoAboutYourself: "Info about yourself",
      infoAboutYourselfDescription: "Tell others about your padel style, vibe, and level (e.g., social player, \n" +
        "competitive, always down for doubles)",
      playerBio: "Player Bio",
      addYourIndustry: "Add your industry",
      peopleCommunicateWhenThereAreCommonTopics: "People communicate more frequently when there are common topics",
      done: "Done",
      yourCity: "Your city",
      wantToLeave: "Are you going to leave?",
      weWillBeWaiting: "We will be waiting for you again for new games and new acquaintances!",
      notNow: "Not now",
      home: "Home",
      notifications: "Notifications",
      youPlayWith: "You play with",
      change: "Change",
      selectLocationForGame: "Select location for game",
      yourInviteHasBeenSent: "Your invite has been sent!",
      pleaseWaitForApproval: "Please wait for the other player to approve it. We’ll notify you as soon as they respond. Thank you for your patience!",
      deleteInvitation: "Delete invitation",
      goToChat: "Go to Chat",
      areYouSureDeleteInvitation: "Are you sure you want to delete this invitation?",
      finishGame: "Finish game",
      areYouSureEndGame: "Are you sure you want to end the game?",
      acceptInvitation: "Accept invitation",
      venueNotSelected: "The court has not been selected.",
      selectACourt: "Select a court",
      usersNotSelected: "The users have not been selected.",
      selectUsers: "Select users",
      afterOpponentsConfirm: "After your opponents confirm the invitation card, you can enter the chat and arrange a meeting.",
      notificationsEmpty: "There are no notifications yet.",
      yesterday: "Yesterday",
      sevenDaysBefore: "7 days before",
      last30Days: "Last 30 days",
      notInvited: "Not invited.",
      pending: "Pending",
      accepted: "Accepted",
      accept: "Accept",
      declined: "Declined",
      decline: "Decline",
      matchConflictTitle: "Match Conflict",
      matchConflictMessage: "You already have a match at this time. Either decline the current invite or leave the match you're already in.",
      completed: "Completed",
      invitations: "Invitations",
      leaveAReview: "Leave a review",
      describeYourExperience: "Describe your experience playing on the court",
      send: "Send",
      yourReview: "Your Review",
      shareYourExperience: "Share your experience with this padel court (e.g. quality of courts, crowd, \n" +
        "vibe)",
      streetAddress: "Street address",
      coachAvailable: "Coach Available",
      socialVibe: "Social Vibe",
      cafeBar: "Café/Bar",
      rentalGear: "Rental Gear Available",
      findAPadelPlace: "Find a place to play padel",
      whatTypeOfCourts: "What type of courts?",
      locationWebsite: "Location website",
      enterTheLocationSite: "Enter the location site",
      approve: "Approve",
      reject: "Reject",
      noLocations: "There are no locations for verification.",
      noAccess: "You do not have access to this page.",
      selectTimeRange: "Select time range",
      morning: "Morning",
      midday: "Midday",
      evening: "Evening",
      selectSkillLevel: "Select skill level",
      selectDayAndMonth: "Select day and month",
      spotsOpen: "{{count}} spot open",
      spotsOpen_other: "{{count}} spots open",
      owner: "Owner",
      noOtherPlayers: "No other players",
      matchDetails: "Match Details",
      matchInfo: "Match Information",
      notFound: "Match not found",
      addUser: "Add Player",
      removeUser: "Remove Player",
      startMatch: "Start match",
      cancelMatch: "Cancel match",
      endMatch: "End match",
      matchEndSuccess: "Match ended successfully",
      matchEndFailure: "Could not end the match. Please try again.",
      matchCancelSuccess: "Match cancelled",
      matchCancelFailure: "Could not cancel the match. Please try again.",
      leaveMatch: "Leave match",
      joinMatch: "Join match",
      removeUserFromMatch: "Remove user from match",
      waitingMatches: "Open matches",
      inProgressMatches: "In progress matches",
      canceledMatches: "Canceled matches",
      completedMatches: "Completed matches",
      noMatches: "No matches found",
      matches: "Matches",
      matchDetail: "Match detail",
      
      // Terms of Service
      termsOfService: {
        padelMatchTermsOfService: "PadelMatch Terms of Service",
        effectiveDate: "Effective Date: 8/1/2025",
        agreementToTermsTitle: "1. Agreement to Terms",
        agreementToTermsContent: 'By downloading, accessing, or using PadelMatch, you agree to be bound by these Terms of Service ("Terms") and our Privacy Policy. If you do not agree, do not use PadelMatch.',
        eligibilityTitle: "2. Eligibility",
        eligibilityContent: "You must be at least 16 years old (or the legal age in your country) to use PadelMatch. By using the Service, you confirm you meet this requirement.",
        theServiceTitle: "3. The Service",
        theServiceContent: "PadelMatch helps users find padel partners and clubs, book courts (when available), and manage their playing schedules. We are not responsible for the condition, safety, or availability of courts or the behavior of other users.",
        userResponsibilitiesTitle: "4. User Responsibilities",
        userResponsibilitiesContent: "You agree to:",
        userResponsibilitiesItem1: "Provide accurate, up-to-date account information.",
        userResponsibilitiesItem2: "Use the Service only for lawful purposes.",
        userResponsibilitiesItem3: "Respect other users and not harass, abuse, or harm anyone.",
        userResponsibilitiesItem4: "Not post false information, spam, or offensive content.",
        paymentsBookingsTitle: "5. Payments & Bookings",
        paymentsBookingsItem1: "If you book a court through PadelMatch, payment terms will be disclosed before purchase.",
        paymentsBookingsItem2: "Cancellations and refunds are subject to the policies of the club or venue.",
        paymentsBookingsItem3: "We are not liable for disputes between you and a club or other users.",
        intellectualPropertyTitle: "6. Intellectual Property",
        intellectualPropertyContent: "PadelMatch, our logo, and all related content are our property or licensed to us. You may not copy, modify, or distribute our materials without permission.",
        terminationTitle: "7. Termination",
        terminationContent: "We may suspend or terminate your account at any time for violating these Terms or for any reason we deem necessary.",
        disclaimersLiabilityTitle: "8. Disclaimers & Limitation of Liability",
        disclaimersLiabilityItem1: 'PadelMatch is provided "as is" without warranties of any kind.',
        disclaimersLiabilityItem2: "We are not liable for injuries, damages, or losses resulting from matches, bookings, or interactions with other users.",
        disclaimersLiabilityItem3: "Our maximum liability to you will not exceed the amount you paid us in the 12 months prior to the event giving rise to the claim.",
        governingLawTitle: "9. Governing Law",
        governingLawContent: "These Terms are governed by the laws of [Insert Jurisdiction], without regard to conflict of law principles.",
        changesToTermsTitle: "10. Changes to Terms",
        changesToTermsContent: "We may update these Terms at any time. Your continued use of PadelMatch after updates means you accept the revised Terms.",
        contactUsTitle: "11. Contact Us",
        contactUsContent: "PadelMatch Support",
        contactUsEmail: "Email: info@padelmatchapp.com",
      },
      
      // Privacy Policy
      privacyPolicy: {
        padelMatchPrivacyPolicy: "PadelMatch Privacy Policy",
        effectiveDate: "Effective Date: 8/1/2025",
        introductionTitle: "1. Introduction",
        introductionContent1: 'PadelMatch ("we," "our," "us") respects your privacy. This Privacy Policy explains how we collect, use, and share your information when you use our mobile application, website, and related services (collectively, the "Service").',
        introductionContent2: "By using PadelMatch, you agree to this Privacy Policy. If you do not agree, please do not use the Service.",
        informationWeCollectTitle: "2. Information We Collect",
        informationYouProvideSubtitle: "a. Information You Provide:",
        informationYouProvideItem1: "Account Info: Name, email address, password, phone number, profile picture, skill level, and other profile details.",
        informationYouProvideItem2: "Preferences: Location, club memberships, availability to play, and match preferences.",
        informationYouProvideItem3: "Communications: Messages you send to other users or to us.",
        informationWeCollectAutomaticallySubtitle: "b. Information We Collect Automatically:",
        informationWeCollectAutomaticallyItem1: "Location Data (with your permission) to help match you with nearby players and clubs.",
        informationWeCollectAutomaticallyItem2: "Device Information: IP address, device type, operating system, and app version.",
        informationWeCollectAutomaticallyItem3: "Usage Data: How you interact with the Service, including searches, matches, and booking activity.",
        informationFromThirdPartiesSubtitle: "c. Information From Third Parties:",
        informationFromThirdPartiesItem1: "Clubs, partners, or booking platforms may share information needed to provide our Service (e.g., court availability).",
        howWeUseYourInformationTitle: "3. How We Use Your Information",
        howWeUseYourInformationContent: "We use your information to:",
        howWeUseYourInformationItem1: "Provide, maintain, and improve PadelMatch.",
        howWeUseYourInformationItem2: "Match you with players and clubs based on your preferences and location.",
        howWeUseYourInformationItem3: "Process court bookings and payments (if applicable).",
        howWeUseYourInformationItem4: "Send you updates, match invites, and promotional offers.",
        howWeUseYourInformationItem5: "Prevent fraud, enforce our Terms, and ensure a safe environment.",
        howWeShareYourInformationTitle: "4. How We Share Your Information",
        howWeShareYourInformationContent: "We do not sell your personal data. We may share your information with:",
        howWeShareYourInformationItem1: "Other Users: Your profile details and availability will be visible to potential match partners and clubs.",
        howWeShareYourInformationItem2: "Service Providers: Payment processors, hosting providers, analytics tools.",
        howWeShareYourInformationItem3: "Legal Requirements: If required by law or to protect our rights.",
        yourChoicesTitle: "5. Your Choices",
        yourChoicesItem1: "Location Sharing: You can disable location in your device settings, but this may limit functionality.",
        yourChoicesItem2: "Account Deletion: Contact us at [email] to delete your account and associated data.",
        yourChoicesItem3: "Marketing Emails: You can unsubscribe at any time.",
        dataSecurityTitle: "6. Data Security",
        dataSecurityContent: "We use reasonable security measures to protect your information, but no system is 100% secure.",
        internationalUsersTitle: "7. International Users",
        internationalUsersContent: "If you use PadelMatch outside your home country, your data may be transferred to and processed in other countries.",
        changesToThisPolicyTitle: "8. Changes to This Policy",
        changesToThisPolicyContent: "We may update this Privacy Policy from time to time. Changes will be posted with a new effective date.",
        contactUsTitle: "9. Contact Us",
        contactUsContent1: "If you have questions, contact:",
        contactUsContent2: "PadelMatch Privacy Team",
        contactUsEmail: "Email: info@padelmatchapp.com",
      },

      // Social Authentication Errors
      googleLoginFailed: "Google login failed. Please try again.",
      authorizationCancelledByUser: "Authorization cancelled by user.",
      appleAuthorizationError: "Apple authorization error. Please try again in a few seconds.",
      appleAuthorizationConfigError: "Apple authorization configuration error.",
      appleLoginError: "Apple login error. Please try again.",
      facebookSdkLoading: "Facebook SDK is still loading, please try again in a moment.",
      appleIdNotLoaded: "Apple ID not loaded!",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;